module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAOBAMAAAC88gOBAAAAAXNSR0IArs4c6QAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB9kKFhYIJV1RdigAAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAAAFVBMVEX4gHh4kBCAeHCouCDY4DD4+Pj///8d/8B4AAAAAXRSTlMAQObYZgAAAAFiS0dEBmFmuH0AAABZSURBVAjXY2BxQQEODM7GKMCEwRgNgARMQ5WNg0yVjYEUVEApCCQAoqACyhABZSW4FiWwgGoQQS1BSFpUg5SNQmFmGCkpA7GxsRLMWlSHCaPyDRkYBVGAAADvSiwAumLcNwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/types/Bug.png
// module id = 157
// module chunks = 0